/**
 * 数据字典 API (JeecgBoot 标准 sys_dict / sys_dict_item)
 *
 * 后端字典表在 JeecgBoot 标准库 (jeecg-system 服务), 经网关 discovery-locator
 * 自动路由, 前端需显式带服务名前缀 /jeecg-system (对齐 request.js 里的
 * /jeecg-system/sys/login).
 *
 * 响应结构: request.js 拦截器对 success=false 直接 reject, 成功时返回 data.result.
 *   - getDictItems  → [{ value, text, ... }]      (DictModel)
 *   - queryAllDictItems → { dictCode: [{value,text}], ... }
 *
 * 调用方注意: 字典拉取失败要 try/catch 回落本地常量, 避免页面白屏
 * (dictionaryCache.js 已内置兜底, 业务层优先用它).
 */
import request from '@/utils/request'

/** 取某个字典类型的全部有效项 (返回 [{ value, text }]) */
export function getDictItems(dictCode) {
  return request.get(`/jeecg-system/sys/dict/getDictItems/${dictCode}`)
}

/** 一次拉全部字典 (返回 { dictCode: [{ value, text }] }), 适合启动时全局缓存 */
export function queryAllDictItems() {
  return request.get('/jeecg-system/sys/dict/queryAllDictItems')
}

/** 按 dictCode + key 反查文案 (单条, 适合偶尔查一次的场景) */
export function getDictText(dictCode, key) {
  return request.get(`/jeecg-system/sys/dict/getDictText/${dictCode}/${encodeURIComponent(key)}`)
}
